import { useQuery } from '@tanstack/react-query';
import { mvpPartnersService } from '../services/mvpPartners.service';
import { MvpPartner } from '../types/mvpPartners';

export const useMvpPartners = () => {
  const query = useQuery<MvpPartner[]>({
    queryKey: ['mvpPartners'],
    queryFn: async () => {
      const partners = await mvpPartnersService.getMvpPartnersFromDedicatedEndpoint();
      return partners;
    }
  });

  const retailerOptions = (query.data || []).map(partner => ({
    label: partner.name,
    value: partner.remoteObjectId || partner.id.toString(),
  }));

  return {
    ...query,
    retailerOptions
  };
};
